module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-325.f6c2355.woff2";